import { useLanguage } from '@/hooks/useLanguage';
import { Building2, Calendar, MapPin, Award, Building } from 'lucide-react';

export const About = () => {
  const { t } = useLanguage();

  const stats = [
    {
      icon: Calendar,
      label: t.stats.established.title,
      value: t.stats.established.description
    },
    {
      icon: MapPin,
      label: t.stats.location.title,
      value: t.stats.location.description
    },
    {
      icon: Building2,
      label: t.stats.industry.title,
      value: t.stats.industry.description
    },
    {
      icon: Award,
      label: t.stats.focus.title,
      value: t.stats.focus.description
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              {t.about.title}
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-primary to-secondary mx-auto rounded-full" />
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Content */}
            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                {t.about.description}
              </p>

              <div className="space-y-4">
                <h3 className="text-xl font-semibold text-gray-900">
                  {t.mission.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {t.mission.description}
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="text-xl font-semibold text-gray-900">
                  {t.commitment.title}
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0" />
                    <span>{t.commitment.item1}</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0" />
                    <span>{t.commitment.item2}</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0" />
                    <span>{t.commitment.item3}</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-6">
              {/* Logo */}
              <div className="col-span-2 flex flex-col items-center mb-4">
                <img
                  src="/images/Logo.png"   // ← วางไฟล์ logo ไว้ที่ public/images
                  alt="Medical Sterilization Systems Co.,Ltd. Logo"
                  className="w-40 h-auto mb-2"
                />
              </div>

              {/* Stats Cards */}
              {stats.map((stat, index) => {
                const IconComponent = stat.icon;
                return (
                  <div
                    key={index}
                    className="bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl text-center hover:shadow-lg transition-all duration-300 hover:scale-105"
                  >
                    <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                      <IconComponent className="w-6 h-6 text-primary" />
                    </div>
                    <div className="space-y-2">
                      <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">
                        {stat.label}
                      </p>
                      <p className="text-lg font-bold text-gray-900">
                        {stat.value}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};